/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
( ( FUNCTIONS ) => {
	const a = 'is-active';
	const v = 'is-visible';

	const yearDropDown = () => {
		if(document.querySelector('.js-news-yearList')) {
			// 最新と最古の年を取得
			const latest = document.querySelector('.js-news-latest-year').textContent;
			const earliest = document.querySelector('.js-news-earliest-year').textContent;
			// ドロップダウンリスト要素を取得
			const yearList = document.querySelector('.js-news-yearList');
			const allOptionVal = () => {
				if(location.pathname.replace('index.html','') == '/news/') {
					return '/news/';
				} else if(location.pathname.replace('index.html','') == '/en/news/') {
					return '/en/news/';
				} else {
					if(location.pathname.match(/\d{4}/)){
						// 文字列に正規表現4桁数値が含まれていたら
						return location.pathname.replace(location.pathname.match(/\d{4}/)[0] + "/", "");
					}else {
						return location.pathname
					}
				}
			};
			const optionVal = (_num) => {
				if(location.pathname.replace('index.html','') == '/news/') {
					return '/news/' + _num + '/';
				} else if(location.pathname.replace('index.html','') == '/en/news/') {
					return '/en/news/' + _num + '/';
				} else {
					if(location.pathname.match(/\d{4}/)){
						// 文字列に正規表現4桁数値が含まれていたら
						return location.pathname.replace(location.pathname.match(/\d{4}/)[0], _num);
					}else {
						if(location.pathname.split('/')[1] == 'news') {
							return '/news/' + _num + '/' + location.pathname.split('/')[2] + "/";
						} else if(location.pathname.split('/')[1] == 'en' && location.pathname.split('/')[2] == 'news') {
							return '/en/news/' + _num + '/' + location.pathname.split('/')[3] + "/";
						}
					}
				}
			};

			// すべてのオプションを生成追加
			if(location.pathname.split('/')[1] == 'news') {
				const allOption = document.createElement('option')
				allOption.textContent = "最新年";
				allOption.value = allOptionVal();
				document.querySelector('.js-news-yearList').appendChild(allOption);
			} else if(location.pathname.split('/')[1] == 'en' && location.pathname.split('/')[2] == 'news') {
				const allOption = document.createElement('option')
				allOption.textContent = "All";
				allOption.value = allOptionVal();
				document.querySelector('.js-news-yearList').appendChild(allOption);
			}

			// 最新から最古の年までのオプションを生成し追加
			for(var i =latest; i>=earliest; i--) {
				const option = document.createElement('option');
				option.textContent = i.toString();
				option.value = optionVal(i);
				document.querySelector('.js-news-yearList').appendChild(option);
			}
			// ドロップダウンリストで選択された年を設定
			if(!(location.pathname.replace('index.html','') == '/news/')) {
				if(!(location.pathname.replace('index.html','') == '/en/news/')) {
					yearList.value = location.pathname;
				}
			}
		}

	}

	const categoryDropDown = () => {
		const categoryList = document.querySelector('.js-news-categoryList');

		const getJSONfiles = () => {
			if(location.pathname.split('/')[1] == 'news') {
				return `/ajax/news/category.json`;
			} else if(location.pathname.split('/')[1] == 'businesstopics') {
				return `/ajax/businesstopics/category.json`;
			} else if(location.pathname.split('/')[1] == 'en' && location.pathname.split('/')[2] == 'news') {
				return `/ajax/en/news/category.json`;
			} else if(location.pathname.split('/')[1] == 'en' && location.pathname.split('/')[2] == 'businesstopics') {
				return `/ajax/en/businesstopics/category.json`;
			}
		};
		fetch(getJSONfiles()).then(function (data) {
			return data.json();
		}).then(function (data) {
			console.log();
			const createOption = (_name, _value) => {
				const option = document.createElement('option');
				option.textContent = _name.toString();
				option.value = _value;
				categoryList.appendChild(option);
			}
			const getBaseOfPath = () => {
				const pathData = location.pathname.split('/');
				if(pathData[1] == 'en') {
					if(location.pathname.match(/\d{4}/)) {
						return pathData[0] + '/' + pathData[1] + "/" + pathData[2] + "/" + pathData[3] + "/"
					} else {
						return pathData[0] + '/' + pathData[1] + "/" + pathData[2] + "/"
					}
				}else {
					if(location.pathname.match(/\d{4}/)) {
						return pathData[0] + '/' + pathData[1] + "/" + pathData[2] + "/"
					} else {
						return pathData[0] + '/' + pathData[1] + "/"
					}
				}
			}

			const baseOfPath = getBaseOfPath()
			if(location.pathname.split('/')[1] == 'news') {
				createOption('すべてのカテゴリ', baseOfPath)
				data.rt_bn_news_category_list.forEach(ele => {
					const path = baseOfPath + ele.cf_nc_code + "/"
					createOption(ele.cf_nc_name, path)
				});
			}else if(location.pathname.split('/')[1] == 'businesstopics') {
				createOption('事業内容で絞り込む', baseOfPath)
				data.rt_bn_news_category_list.forEach(ele => {
					const path = baseOfPath + ele.cf_nc_code + "/"
					createOption(ele.cf_nc_name, path)
				});
			}else if(location.pathname.split('/')[1] == 'en' && location.pathname.split('/')[2] == 'news') {
				createOption('All', baseOfPath)
				data.rt_bn_news_category_list.forEach(ele => {
					const path = baseOfPath + ele.cf_nc_code + "/"
					createOption(ele.cf_nc_name_en, path)
				});
			}else if(location.pathname.split('/')[1] == 'en' && location.pathname.split('/')[2] == 'businesstopics') {
				createOption('All', baseOfPath)
				data.rt_bn_news_category_list.forEach(ele => {
					const path = baseOfPath + ele.cf_nc_code + "/"
					createOption(ele.cf_nc_name_en, path)
				});
			}

			// ドロップダウンリストで選択された内容を設定
			if(!(location.pathname.replace('index.html','') == '/news/')) {
				if(!(location.pathname.replace('index.html','') == '/en/news/')) {
					categoryList.value = location.pathname;
				}
			}

		})
	};

	yearDropDown();
	categoryDropDown();


} )( window.FUNCTIONS );
